import { FC } from 'react'
import moment from 'moment'
import { StatusModal } from 'src/components/StatusModal'
import styles from './noDataModal.module.scss'

interface NoDataModalProps {
  fromDate?: moment.Moment | null
  isOpen: boolean
  onClose: () => void
  toDate?: moment.Moment | null
}

const WarningTriangleIcon: FC = () => (
  <svg fill="none" height="54" viewBox="0 0 48 48" width="54">
    <path
      d="M24 18v10M24 34h.02M21.43 7.71 4.5 36a3 3 0 0 0 2.57 4.5h33.86A3 3 0 0
      0 43.5 36L26.57 7.71a3 3 0 0 0-5.14 0Z"
      fill="#FF6833"
      stroke="#FF6833"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M24 18v10M24 34h.02"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
)

export const NoDataModal: FC<NoDataModalProps> = ({
  fromDate,
  isOpen,
  onClose,
  toDate,
}) => {
  const format = (d?: moment.Moment | null) =>
    d ? d.format('DD/MM/YYYY') : '—'

  return (
    <StatusModal
      doneLabel="Got It"
      hideCountdown
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={styles.iconCircle}>
        <WarningTriangleIcon />
      </div>
      <h2 className={styles.title}>No Data Found For the Selected Period</h2>
      <p className={styles.message}>
        We couldn&apos;t find any data between {format(fromDate)} and{' '}
        {format(toDate)}.
        <br />
        <span className={styles.messageBold}>
          Please select a different date range.
        </span>
      </p>
    </StatusModal>
  )
}
